import React from "react";
import {
  NotificationBanner,
  BannerSeverity,
  Icon,
  IconName,
  useDeviceTypes,
} from "halifax";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import { getMaxRefund } from "../PriceDropProtection/textConstants";
import { PRICE_DROP_FO_CREDIT_BANNER_LABEL } from "./textConstants";
import { PriceDropFOCreditBannerConnectorProps } from "./container";
import "./styles.scss";

export const PriceDropFOCreditBanner = (
  props: PriceDropFOCreditBannerConnectorProps
) => {
  const { isEligible, priceDropProtection } = props;
  const { matchesMobile } = useDeviceTypes();

  if (!isEligible || !priceDropProtection) {
    return null;
  }

  return (
    <Box
      className={clsx("price-drop-fo-credit-banner-root", {
        mobile: matchesMobile,
      })}
    >
      <NotificationBanner
        className="price-drop-fo-credit-banner"
        label={PRICE_DROP_FO_CREDIT_BANNER_LABEL(
          getMaxRefund(priceDropProtection)
        )}
        severity={BannerSeverity.IMPROVEMENT}
        icon={
          <Icon
            className="banner-icon"
            name={IconName.PriceDropProtectionShield}
          />
        }
      />
    </Box>
  );
};
